<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-message-square" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Enrollee Feedback</h4>
              <small style="opacity: .8;">
                <span v-if="comments.total">{{ comments.total }} feedback records</span>
                <span v-else>Facility ratings and reviews</span>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Filter Card -->
        <div class="card table-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-filter" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Filter Feedback</p>
              <small style="color:rgba(255,255,255,.7);">Filter by facility and date range</small>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="form-group col-md-4" v-if="user.type == 'shis' || user.type == 'employee'">
                <label class="info-label d-block mb-1">Select Facility</label>
                <v-select v-model="form.provider_id" :reduce="agency_name => agency_name.id"
                  label="agency_name" :options="providers" />
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                <input type="date" class="form-control" v-model="form.from" />
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                <input type="date" class="form-control" v-model="form.to" />
              </div>

              <div class="col-md-12 pt-2 border-top">
                <button class="btn btn-submit px-4" @click="getComments">
                  <i class="fe fe-filter mr-1"></i> Filter
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Table Card -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-star text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Feedback Records</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Enrollee</th>
                  <th class="table-th">Facility</th>
                  <th class="table-th">Rating</th>
                  <th class="table-th">Comment</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="trf in comments.data" v-bind:key="trf.id">
                  <td>
                    <span v-if="trf.user != null" class="font-weight-bold">{{ trf.user.full_name }}</span>
                  </td>
                  <td>{{ trf.provider.agency_name }}</td>
                  <td>
                    <span v-if="trf.health_record != null">
                      <star-rating star-size="14" :rating="trf.health_record.rating.score"
                        :show-rating="false" read-only="true" active-color="#198754"></star-rating>
                    </span>
                  </td>
                  <td>
                    <span style="font-size:.88rem;">{{ trf.body }}</span>
                    <small class="text-muted d-block mt-1">{{ trf.created_at | moment("from", "now") }}</small>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-secondary" data-toggle="modal"
                      data-target="#slideRightModalAll" @click="getRequest(trf)">
                      <i class="fe fe-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-2">
            <div class="d-flex justify-content-end align-items-center" style="gap: 8px;">
              <button class="btn btn-sm btn-outline-secondary" @click="DecreamentPage">
                <i class="fe fe-chevron-left"></i> Previous
              </button>
              <span class="font-weight-bold px-2">{{ pageNum }}</span>
              <button class="btn btn-sm btn-outline-secondary" @click="IncreamentPage">
                Next <i class="fe fe-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Detail Modal -->
        <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content" id="printDiv" ref="printNow">
              <div class="modal-header" v-if="single_request" style="background: linear-gradient(135deg, #1e3a5f, #2563eb);">
                <div class="d-flex align-items-center" style="gap:8px;">
                  <span class="h6 mb-0 text-white font-weight-bold">Feedback Detail</span>
                  <a class="badge badge-light btn-sm" role="button" target="_blank"
                    :href="`/encounter/${single_request.health_record.id}`">
                    Encounter <i class="mdi mdi-medical-bag ml-1"></i>
                  </a>
                </div>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body p-0" v-if="single_request">
                <ul class="list-unstyled mb-0">
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Enrollee Name</p>
                      <p class="info-value">{{ single_request.user.full_name }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-credit-card info-icon"></i>
                    <div>
                      <p class="info-label">Enrollee ID</p>
                      <p class="info-value"><span class="code-chip">{{ single_request.user.id_card_number }}</span></p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ single_request.user.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-grid info-icon"></i>
                    <div>
                      <p class="info-label">Programme</p>
                      <p class="info-value">{{ single_request.user.sector }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-activity info-icon"></i>
                    <div>
                      <p class="info-label">Health Facility</p>
                      <p class="info-value">
                        <a class="badge badge-soft-info" :href="`/provider-${single_request.provider_id}`" target="_blank">
                          {{ single_request.provider.agency_name }}
                        </a>
                      </p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-message-circle info-icon"></i>
                    <div>
                      <p class="info-label">Comment</p>
                      <p class="info-value">{{ single_request.body }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-clock info-icon"></i>
                    <div>
                      <p class="info-label">Date</p>
                      <p class="info-value">{{ single_request.created_at | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="modal-footer" v-if="single_request">
                <a :href="`/encounter/${single_request.health_record.id}`" class="btn btn-submit">
                  <i class="mdi mdi-medical-bag mr-1"></i> View Encounter
                </a>
                <a :href="`/provider-${single_request.provider_id}`" class="btn btn-outline-secondary">
                  <i class="fe fe-activity mr-1"></i> View Provider
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </main>

    <div class="vld-parent">
      <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import StarRating from "vue-star-rating";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Navbar,
    Loading,
    StarRating,
  },
  data() {
    return {
      agency: agency,
      user: null,
      search_result: "",
      enrollee_details: "",
      searchkey: "",
      comments: "",
      transfers: "",
      providers: "",
      history: "",
      single_request: null,
      pageNum: 1,
      edit: false,
      isLoading: false,
      show: false,
      fullPage: true,
      form: {
        provider_id: "",
        from: "",
        to: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    //
  },
  methods: {
    getComments() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/comments`, {
          params: {
            paginate_value: 30,
            agency_id: agency.id,
            provider_id: this.form.provider_id,
            from: this.form.from,
            to: this.form.to,
          },
        })
        .then((response) => {
          this.comments = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getRequest(trf) {
      this.isLoading = true;

      this.single_request = trf;

      this.isLoading = false;
    },

    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/${this.agency.id}`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    IncreamentPage() {
      this.pageNum = this.pageNum + 1;
      this.getComments();
    },
    DecreamentPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
        this.getComments();
      }
    },
  },
  created() {
    this.getComments();
    this.getProviders();
  },
};
</script>
